module.exports = __webpack_public_path__ + "img/icon_t21.6a971fa7.png";